/**
 * Coordination entre la redirection de chargement (arrivée sans session) et la modale de
 * reconnexion (session expirée en cours d'usage) : quand la coquille redirige vers /connexion,
 * la modale ne doit pas s'ouvrir par-dessus.
 */
let redirection = false;

export function marquerRedirectionConnexion(): void {
  redirection = true;
}

export function redirectionConnexionEnCours(): boolean {
  return redirection;
}

/** Réservé aux tests. */
export function reinitialiserRedirectionConnexion(): void {
  redirection = false;
}
